export default "__VITE_ASSET__BKt3Punp__"